export * from './org-detail.resolver';
export * from './organization-contact.resolver';
